import { MediaContentDTO, ProductSkuDTO, isLocalId } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
import RootStore  from 'mobx-stores/root-store'
import { Api } from "services"

export class ProductImagesStore {
  private rootStore:any
  private productsApi: Api['productsApi']

  constructor (rootStore:any) {
    this.rootStore = rootStore
    this.productsApi = this.rootStore.generalStore.api.productsApi
    makeAutoObservable(this)
  }

  // OBSERVABLES
  private productImages: Partial<MediaContentDTO[]> = [] // TODO-A To make it with useEffect maybe
  public initialImages: Partial<MediaContentDTO[]> = []
  // public allProductSkus: ProductSkuDTO[] = []

  // ACTIONS
  public setProductImagesStore = (
    productImages: Partial<MediaContentDTO[]>
  ): void => {
    this.productImages = productImages
  }

  public setInitialImages = (
    productImages: Partial<MediaContentDTO[]>
  ): void => {
    // this.productImages = productImages;
    this.initialImages = productImages
  }

  public setProductImagesStoreProps = (
    props: Partial<MediaContentDTO[]>
  ): void => {
    // const imageDTO: Partial<MediaContentDTO> = {
    //   backgroundImage: true,
    //   contentType: '',
    //   createdDate: 0,
    //   label: '',
    //   mainImage: true,
    //   originalHeight: 0,
    //   originalWidth: 0,
    //   portrait: true,
    //   portraitWidth: 0,
    //   portraitX: 0,
    //   portraitY: 0,
    //   square: true,
    //   squareWidth: 0,
    //   squareX: 0,
    //   squareY: 0,
    //   url: ''
    // }

    // const images = props.map(mediaContent => {
    //   return {...imageDTO, ...mediaContent}
    // });

    // this.setProductImagesStore([ ...this.productImages, ...images])
    this.setProductImagesStore(props)
  }

  // private setAllProductSkus = (skus: ProductSkuDTO[]): void => {
  //   this.allProductSkus = skus
  // }

  // COMPUTED
  public get productInitialImagesStore (): Partial<MediaContentDTO[]> {
    return this.initialImages
  }

  public get productImagesStore (): Partial<MediaContentDTO[]> {
    return this.productImages
  }

  // METHODS
  public updateProductImages = async (
    productId: number | string
  ): Promise<MediaContentDTO[]> => {
    // this.rootStore.viewProductsPageStore.updateProductImages([...this.productImages, ...this.initialImages], productId);
    return await this.rootStore.viewProductsPageStore.updateProductImages(
      this.productImages,
      productId
    )
  }

  InitProductImages = (): void => {
    this.setProductImagesStore([]);
    this.setInitialImages([]);
  }

  public analyzeAndUpdateSkuImages = async (args: {
    skusBefore: ProductSkuDTO[]
    skusAfter: ProductSkuDTO[]
    images: MediaContentDTO[]
    imagesWithLocalIds: MediaContentDTO[]
    productId: number | string
  }): Promise<void> => {
    const actionsBySkuId: Map<
      number,
      { imagesToRemoveIds: number[]; imagesToAddIds: number[] }
    > = new Map()

    const {
      skusAfter,
      skusBefore,
      images,
      imagesWithLocalIds,
      productId
    } = args

    const isSameSkus = JSON.stringify(skusBefore) === JSON.stringify(skusAfter)
    const isHaveNewImages = imagesWithLocalIds.length > 0;

    const skusAfterMap = new Map(skusAfter.map(sku => [sku.id, sku]))
    skusBefore.forEach(skuBefore => {
      const skuAfter = skusAfterMap.get(skuBefore.id)
      if (!skuAfter) {
        this.rootStore.generalStore.showError('Product SKUs mismatch.')
        return
      }
      const skuBeforeImageIds = skuBefore.images.map(img => img.id)
      const skuAfterImageIds = skuAfter.images.map(img => img.id)

      const imagesRemovedIds = skuBeforeImageIds.filter(
        id => !skuAfterImageIds.includes(id)
      )
      const imagesAddedIds = skuAfterImageIds.filter(
        id => !skuBeforeImageIds.includes(id)
      )

      if (Boolean(imagesAddedIds.length || imagesRemovedIds.length))
        actionsBySkuId.set(skuBefore.id, {
          imagesToAddIds: imagesAddedIds,
          imagesToRemoveIds: imagesRemovedIds
        })
    })

    const imagesMap: Map<number, MediaContentDTO> = new Map(
      images?.map(img => [img?.id, img])
    )
    const imagesWithLocalIdsMap: Map<number, MediaContentDTO> = new Map(
      imagesWithLocalIds.map(img => [img.id, img])
    )

    const getImageById = (imageId: number): MediaContentDTO => {
      const getImageByLocalId = (localImageId: number): MediaContentDTO => {
        const imageWithLocalId = imagesWithLocalIdsMap.get(localImageId)
        return images.find(img => img.url === imageWithLocalId.url)
      }

      const image = isLocalId(imageId)
        ? getImageByLocalId(imageId)
        : imagesMap.get(imageId)

      return image
    }

    // const promises = []
    // actionsBySkuId.forEach(({ imagesToAddIds, imagesToRemoveIds }, skuId) => {
    //   imagesToAddIds.forEach(imageId => {
    //     promises.push(
    //       this.rootStore.generalStore.api.productSkuApi.addImage({
    //         image: getImageById(imageId),
    //         productSkuId: skuId
    //       })
    //     )
    //   })

    //   imagesToRemoveIds.forEach(imageId => {
    //     promises.push(
    //       this.rootStore.generalStore.api.productSkuApi.removeImage({
    //         imageId,
    //         productSkuId: skuId
    //       })
    //     )
    //   })
    // })


    // if (!promises.length) return

    // const result = await Promise.all(promises)
    // if (!result.length) return

    const skusWithImgDTO = skusAfter.map(sku => {
      return {
      ...sku, 
      images: sku.images.map(
      img => getImageById(img.id)).filter(Boolean)
        }
      }
    )

    if (isSameSkus && isHaveNewImages) {
    await this.productsApi.updateAllProductGallerySkus(productId, [])
    } else { 
    await this.productsApi.updateAllProductGallerySkus(productId, skusWithImgDTO)
    }

    const product = await this.rootStore.generalStore.api.storeApi.getProductById(
      productId
    )

    // Refresh the product details
    this.rootStore.productsDetailsStore.setProductDetailsStore(product);

    if (!product) return
    this.rootStore.viewProductsPageStore.setStoreProps({
      productSkus: product.productSkus
    })

    // TODO: Update the SKUs in the SKUs table
  }
}
